import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";

import { configureStore } from "./store";
import { cpmRealgridUtils } from "script/cpmRealgrid-utils";
import jszip from "script/jszip";
import { cpmRealgridTreeUtils } from "script/realgrid-treeview-utils";
import "./i18n" ;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={configureStore({})}>
    <BrowserRouter basename={process.env.REACT_APP_BASE_URL}>
      <App />
    </BrowserRouter>
  </Provider>
);

cpmRealgridUtils();
cpmRealgridTreeUtils();
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
jszip();
